import { FolderOpen, Layout, Sparkles } from 'lucide-react';
import type { View } from '../App';

interface HeaderProps {
  currentView: View;
  onViewChange: (view: View) => void;
}

export function Header({ currentView, onViewChange }: HeaderProps) {
  const navItems: { view: View; label: string; icon: any }[] = [
    { view: 'templates', label: 'Templates', icon: Layout },
    { view: 'projects', label: 'My Memes', icon: FolderOpen },
  ];

  return (
    <header className="bg-white/70 backdrop-blur-lg border-b border-gray-200/50 sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3 group cursor-pointer">
            <div className="w-12 h-12 bg-gradient-to-br from-primary-400 to-primary-600 rounded-2xl flex items-center justify-center shadow-lg shadow-primary-500/30 group-hover:shadow-primary-500/50 transition-all duration-300 group-hover:scale-105">
              <Sparkles className="text-white" size={24} strokeWidth={2.5} />
            </div>
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-primary-600 to-primary-500 bg-clip-text text-transparent">
                Meme Studio
              </h1>
              <p className="text-xs text-gray-500 font-medium">Create & Share</p>
            </div>
          </div>

          <nav className="flex items-center gap-2 bg-gray-100/80 backdrop-blur-sm p-1.5 rounded-2xl">
            {navItems.map(({ view, label, icon: Icon }) => (
              <button
                key={view}
                onClick={() => onViewChange(view)}
                className={`
                  flex items-center gap-2 px-6 py-2.5 rounded-xl font-semibold transition-all duration-200
                  ${currentView === view
                    ? 'bg-white text-primary-600 shadow-md scale-105'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-white/50'
                  }
                `}
              >
                <Icon size={18} strokeWidth={2.5} />
                <span>{label}</span>
              </button>
            ))}
          </nav>

          <div className="w-12"></div>
        </div>
      </div>
    </header>
  );
}
